import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: "0",
    marginTop: "10px",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    [theme.breakpoints.down("xl")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
}));
